import React, { useEffect } from 'react'
import { Radio } from 'antd'
import { useLocation, history } from '@umijs/max'

interface ModuleTabsProps {
  onTabChange?: (activeKey: string) => void
  workspaceMenus?: any[]
  manageMenus?: any[]
}

const ModuleTabs: React.FC<ModuleTabsProps> = ({ 
  onTabChange, 
  workspaceMenus = [], 
  manageMenus = [] 
}) => {
  const location = useLocation()
  
  // 根据当前路径确定激活的tab
  const getActiveKey = () => {
    if (location.pathname.startsWith('/manage')) {
      return 'manage'
    } else if (location.pathname.startsWith('/workspace')) {
      return 'workspace'
    }
    // 默认返回workspace
    return 'workspace'
  }
  
  // 判断是否显示工作台按钮
  const showWorkspace = workspaceMenus && workspaceMenus.length > 0
  // 判断是否显示管理按钮
  const showManage = manageMenus && manageMenus.length > 0

  const handleTabChange = (e: any) => {
    const activeKey = e.target.value
    console.log('Tab changed to:', activeKey)
    
    // 先跳转路由
    if (activeKey === 'workspace') {
      history.push('/workspace/welcome')
    } else if (activeKey === 'manage') {
      history.push('/manage/welcome')
    }
    
    // 路由跳转后更新状态，触发菜单重新加载
    setTimeout(() => {
      onTabChange?.(activeKey)
    }, 50)
  }

  // 监听路径变化，确保tab状态同步
  useEffect(() => {
    const activeKey = getActiveKey()
    console.log('Path changed, updating tab to:', activeKey)
    onTabChange?.(activeKey)
  }, [location.pathname, onTabChange])

  // 如果两个按钮都不显示，则不渲染组件
  if (!showWorkspace && !showManage) {
    return null
  }
  
  // 构建选项数组
  const options: Array<{ label: string; value: string }> = []
  if (showWorkspace) {
    options.push({ label: '工作台', value: 'workspace' })
  }
  if (showManage) {
    options.push({ label: '管理', value: 'manage' })
  }
  
  return (
    <div>
      <Radio.Group
        value={getActiveKey()}
        onChange={handleTabChange}
        optionType="button"
        buttonStyle="solid"
        options={options}
      />
    </div>
  )
}

export default ModuleTabs 